import * as React from 'react';

import classNames from 'classnames';

import styles from './page-content-two-column.module.css';

type Props = {
    leftContent: React.ReactNode;
    rightContent: React.ReactNode;
    withoutOuterPadding?: boolean;
    overflowVisible?: boolean;
};

export function PageContentTwoColumn(props: Props) {
    return (
        <div
            className={classNames({
                [styles.container]: true,
                [styles['container--overflow-visible']]: props.overflowVisible,
            })}
        >
            <div
                className={classNames({
                    [styles['left-container--without-outer-padding']]: props.withoutOuterPadding,
                    [styles['left-container']]: !props.withoutOuterPadding,
                    [styles['left-container--overflow-visible']]: props.overflowVisible,
                })}
            >
                {props.leftContent}
            </div>
            <div
                className={classNames({
                    [styles['right-container--without-outer-padding']]: props.withoutOuterPadding,
                    [styles['right-container']]: !props.withoutOuterPadding,
                    [styles['right-container--overflow-visible']]: props.overflowVisible,
                })}
            >
                {props.rightContent}
            </div>
        </div>
    );
}
